export default __webpack_public_path__ + "static/media/callum.2584354d.jpg";